import Flickity from "flickity";
require('flickity-imagesloaded');
import axios from "axios";
import Handlebars from "handlebars";
import getBreakpoint from "../helpers/get-breakpoint";
import debounce from "../helpers/debounce";

class ClientsGrid {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.groupTemplate = Handlebars.compile(document.getElementById("clients-grid-template").innerHTML);
        self.itemTemplate = Handlebars.compile(document.getElementById("clients-grid-item-template").innerHTML);
        self.gridConfig = {
            'xs': {
                'groupSize': 6,
                'maxGroups': 4,
            },
            'sm': {
                'groupSize': 6,
                'maxGroups': 4,
            },
            'md': {
                'groupSize': 9,
                'maxGroups': 3,
            },
            'lg': {
                'groupSize': 12,
                'maxGroups': 3,
            },
            'xl': {
                'groupSize': 18,
                'maxGroups': 2,
            },
            'xxl': {
                'groupSize': 18,
                'maxGroups': 2,
            },
        };

        self.browserWidth = document.body.offsetWidth;
    }

    init() {
        let self = this;

        // Get logos from Element API
        axios.get('/api/client-logos.json')
            .then(function (response) {
                // Build the grid
                self.buildGrid(response.data);

                let rebuildGrid = debounce(function () {
                    self.buildGrid(response.data);
                });
        
                window.addEventListener('resize', function () {
                    if(document.body.offsetWidth != self.browserWidth) {
                        rebuildGrid();
                        self.browserWidth = document.body.offsetWidth;
                    }
                }, false);
            })
            .catch(function (error) {
                // handle error
                console.log(error);
            });
    }

    buildGrid(data) {
        let self = this;
        let groupSize = self.gridConfig[getBreakpoint()].groupSize;
        let pageCount = Math.min(Math.ceil(data.length / groupSize), self.gridConfig[getBreakpoint()].maxGroups);
        let groupsHtml = '';

        // If Flickity has already been instantiated, destroy it
        if(self.hasOwnProperty('flkty')) {
            self.flkty.destroy();
            delete self.flkty;
        }

        // Empty the grid container
        self.elem.textContent = '';
        
        for (let i = 1; i <= pageCount; i++) {
            // Group the data into arrays, each containing $groupSize items
            let items = data.slice((i - 1) * groupSize, i * groupSize);
            
            // Create the HTML for all the items
            let itemsHtml = '';

            items.forEach(item => {
                let itemContext = { logoUrl: item.url, logoAlt: item.title };
                let itemHtml = self.itemTemplate(itemContext);
                itemsHtml = itemsHtml + itemHtml;
            });

            // Create the HTML for the group, passing in the items
            let groupContext = { items: itemsHtml };
            let groupHtml = self.groupTemplate(groupContext);
            groupsHtml = groupsHtml + groupHtml;
        }

        self.elem.insertAdjacentHTML( 'beforeend', groupsHtml );

        // Init Flickity
        self.initFlickity();
    }

    initFlickity() {
        let self = this;

        // Init Flickity
        self.flkty = new Flickity(self.elem, {
            autoPlay: 5000,
            draggable: false,
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            pauseAutoPlayOnHover: false,
            imagesLoaded: true,
            selectedAttraction: 1,
            friction: 1,
        });
    }
}

export default ClientsGrid;
